import React from "react";
import { Link } from "react-router-dom";
import styles from "../../styles/case-manager-modules/StatusCard.module.css";

const StatusCard = ({ percentage, time, description, buttonText, buttonLink, title, Icon, ArrowIcon, onClick }) => {
  return (
    <div className={styles.card}>
      <div className={styles.info}>
        <span className={styles.percentage}>{percentage}</span>
        {ArrowIcon && <ArrowIcon size={20} className={styles.icon} />}
         <span className={styles.time}>{time}</span>
       {/* <p className={styles.description}>
          {Icon && <Icon size={20} className={styles.clockIcon} />} {description}
        </p> */}
      </div>

      {buttonLink ? (
        <Link to={buttonLink} className="button">
          {buttonText}
        </Link>
      ) : onClick ? (
        <button className="button" onClick={onClick}>
          {buttonText}
        </button>
      ) : (
        <button className="button" disabled>
          {buttonText}
        </button>
      )}
    </div>
  );
};

export default React.memo(StatusCard);
